/**
 * array가 비어있는지 여부 리턴
 */
export function isEmptyArray(array) {
    return array === null || array.length === 0;
}

/**
 * array의 요소들을 모두 더한 값을 리턴
 */
export function arraySum(data, index) {
    return data.map((row) => row[index]).reduce((sum, i) => sum + i, 0);
}

/**
 * primitive type 배열(data)에서 value 를 포함하는지 여부 리턴
 */
export function contains(data, value) {
    return data.indexOf(value) > -1;
}

/**
 * Json 배열(data)에서 key와 value에 해당하는 Json 요소를 포함하는지 여부 리턴
 */
export function containsJsonElement(data, key, value) {
    return data.findIndex((row) => row[key] === value) > -1;
}

export function containsJsonElementMultiKey(data, key1, value1, key2, value2) {
    return data.some(
        (row) => row[key1] === value1 && row[key2] === value2
    );
}

/**
 * Json 배열(data)에서 key와 value에 해당하는 Json 요소 리턴
 */
export function firstWhere(data, key, value) {
    return data.find((row) => row[key] === value);
}

/**
 * Json 배열(data)에서 key와 value에 해당하는 Json 요소의 "인덱스" 리턴
 */
export function firstWhereIdx(data, key, value) {
    return data.findIndex((row) => row[key] === value);
}

export function firstWhereIdxMultiKey(data, key1, value1, key2, value2) {
    return data.findIndex((row) => row[key1] === value1 && row[key2] === value2);
}

/**
 * primitive type 배열(data)에서 value에 해당하는 요소를 삭제한 배열 리턴
 */
export function deleteElement(data, value) {
    const idx = data.indexOf(value);
    if (idx > -1) data.splice(idx, 1);
    return data;
}

/**
 * 배열(data)에서 index에 해당하는 요소를 삭제한 배열 리턴
 */
export function deleteElementByIndex(data, index) {
    data.splice(index, 1);
    return data;
}

/**
 * Json 배열(data)에서 key와 value에 해당하는 Json 요소를 삭제한 배열 리턴
 */
export function deleteJsonElement(data, key, value) {
    let idx = firstWhereIdx(data, key, value);
    if (idx > -1) data.splice(idx, 1);
    return data;
}


export function deleteJsonElementMultiKey(data, key1, value1, key2, value2) {
    let idx = firstWhereIdxMultiKey(data, key1, value1, key2, value2);
    if (idx > -1) data.splice(idx, 1);
    return data;
}


/**
 * Json 배열(data)에서 파라미터(key)에 해당하는 값만 추출하여 만든 배열 리턴
 */
export function pluck(data, key) {
    let arr = [];
    data.map(item => arr.push(item[key]));
    return arr;
}

/**
 * primitive type 을 원소로 하는 배열(data)의 값들을 구분자(delimiter)로 연결한 문자열 리턴
 */
export function concatToStr(data, delimiter) {
    let str = "";

    data.filter(Boolean).forEach((item, index) => {
        if (index === 0) {
            str += item;
        } else {
            str += delimiter + item;
        }
    });

    return str;
}
